import LandingPage from "./LandingPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <LandingPage />
      <ToastContainer
        position="top-right"
        autoClose={3000} // tempo di chiusura in ms
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored" // puoi provare anche "light" o "dark"
      />
    </>
  );
}

export default App;
